import React from 'react';

function Art({ children, size = 140 }) {
  return (
    <svg
      className="art"
      width={size}
      height={Math.round(size * 0.72)}
      viewBox="0 0 200 144"
      fill="none"
      aria-hidden="true"
      focusable="false"
    >
      {children}
    </svg>
  );
}

const grad = (id) => (
  <defs>
    <linearGradient id={id} x1="0" y1="0" x2="1" y2="1">
      <stop offset="0%" stopColor="#6d5cff" />
      <stop offset="100%" stopColor="#00d4a0" />
    </linearGradient>
  </defs>
);

export function ArtBox({ size }) {
  return (
    <Art size={size}>
      {grad('g-box')}
      <ellipse cx="100" cy="124" rx="66" ry="9" fill="#6d5cff" opacity="0.14" />
      <path d="M44 78l56-24 56 24-56 24Z" fill="url(#g-box)" opacity="0.25" />
      <path d="M44 78v28l56 24 56-24V78" stroke="url(#g-box)" strokeWidth="3" strokeLinejoin="round" fill="#121826" />
      <path d="M100 102v28" stroke="url(#g-box)" strokeWidth="3" />
      <path d="M44 78l56 24 56-24" stroke="url(#g-box)" strokeWidth="3" strokeLinejoin="round" />
      <path d="M72 66l56-24" stroke="#8b96ad" strokeWidth="2.5" strokeLinecap="round" opacity=".6" />
      <circle cx="150" cy="42" r="7" fill="#00d4a0" opacity=".8" />
      <path d="M54 44h16M62 36v16" stroke="#6d5cff" strokeWidth="3" strokeLinecap="round" />
    </Art>
  );
}

export function ArtChart({ size }) {
  return (
    <Art size={size}>
      {grad('g-chart')}
      <ellipse cx="100" cy="126" rx="70" ry="8" fill="#6d5cff" opacity="0.14" />
      <rect x="38" y="30" width="124" height="82" rx="10" fill="#121826" stroke="url(#g-chart)" strokeWidth="3" />
      <path d="M54 96l24-26 20 16 26-34 22 24" stroke="url(#g-chart)" strokeWidth="3.5" strokeLinecap="round" strokeLinejoin="round" fill="none" />
      <circle cx="98" cy="86" r="5" fill="#00d4a0" />
      <circle cx="124" cy="52" r="5" fill="#6d5cff" />
      <path d="M54 104h96" stroke="#232c40" strokeWidth="3" strokeLinecap="round" />
      <rect x="58" y="60" width="10" height="18" rx="3" fill="#6d5cff" opacity=".45" />
      <rect x="76" y="52" width="10" height="26" rx="3" fill="#00d4a0" opacity=".45" />
    </Art>
  );
}

export function ArtDoc({ size }) {
  return (
    <Art size={size}>
      {grad('g-doc')}
      <ellipse cx="100" cy="126" rx="58" ry="8" fill="#6d5cff" opacity="0.14" />
      <path d="M64 24h50l24 24v72a6 6 0 0 1-6 6H64a6 6 0 0 1-6-6V30a6 6 0 0 1 6-6Z" fill="#121826" stroke="url(#g-doc)" strokeWidth="3" strokeLinejoin="round" />
      <path d="M114 24v24h24" stroke="url(#g-doc)" strokeWidth="3" strokeLinejoin="round" />
      <path d="M76 62h48M76 78h48M76 94h30" stroke="#8b96ad" strokeWidth="3.5" strokeLinecap="round" opacity=".7" />
      <circle cx="138" cy="98" r="14" fill="url(#g-doc)" />
      <path d="M132 98l4.5 4.5L145 94" stroke="#0b0f17" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
    </Art>
  );
}

export function ArtUsers({ size }) {
  return (
    <Art size={size}>
      {grad('g-users')}
      <ellipse cx="100" cy="126" rx="64" ry="8" fill="#6d5cff" opacity="0.14" />
      <circle cx="76" cy="56" r="18" fill="#121826" stroke="url(#g-users)" strokeWidth="3" />
      <path d="M46 108c0-17 13-28 30-28s30 11 30 28" stroke="url(#g-users)" strokeWidth="3" strokeLinecap="round" fill="#121826" />
      <circle cx="132" cy="64" r="14" fill="#121826" stroke="#8b96ad" strokeWidth="2.5" opacity=".8" />
      <path d="M112 106c0-13 9-22 22-22s22 9 22 22" stroke="#8b96ad" strokeWidth="2.5" strokeLinecap="round" fill="#121826" opacity=".8" />
      <path d="M138 40l3 6 6 3-6 3-3 6-3-6-6-3 6-3Z" fill="#00d4a0" />
    </Art>
  );
}

export function ArtMega({ size }) {
  return (
    <Art size={size}>
      {grad('g-mega')}
      <ellipse cx="100" cy="126" rx="60" ry="8" fill="#6d5cff" opacity="0.14" />
      <path d="M62 60l58-22v68L62 84Z" fill="#121826" stroke="url(#g-mega)" strokeWidth="3" strokeLinejoin="round" />
      <path d="M120 38c14 8 22 20 22 34s-8 26-22 34" stroke="url(#g-mega)" strokeWidth="3" strokeLinecap="round" fill="none" />
      <path d="M62 60v24a10 10 0 0 0 10 10h6l4 18H70a10 10 0 0 1-10-10V70" fill="#121826" stroke="url(#g-mega)" strokeWidth="3" strokeLinejoin="round" />
      <path d="M146 52l6-8M154 70h10M146 88l6 8" stroke="#00d4a0" strokeWidth="3" strokeLinecap="round" />
    </Art>
  );
}

export function ArtSearch({ size }) {
  return (
    <Art size={size}>
      {grad('g-search')}
      <ellipse cx="100" cy="126" rx="56" ry="8" fill="#6d5cff" opacity="0.14" />
      <rect x="44" y="34" width="112" height="70" rx="10" fill="#121826" stroke="url(#g-search)" strokeWidth="3" />
      <path d="M44 54h112" stroke="url(#g-search)" strokeWidth="3" />
      <circle cx="56" cy="44" r="4" fill="#ff5b6b" />
      <circle cx="70" cy="44" r="4" fill="#f5a623" />
      <circle cx="84" cy="44" r="4" fill="#2ecc71" />
      <circle cx="96" cy="82" r="16" stroke="url(#g-search)" strokeWidth="3.5" fill="none" />
      <path d="M108 94l14 14" stroke="url(#g-search)" strokeWidth="4" strokeLinecap="round" />
      <path d="M64 82h14M64 94h8" stroke="#8b96ad" strokeWidth="3" strokeLinecap="round" opacity=".7" />
    </Art>
  );
}

const KINDS = {
  box: ArtBox,
  chart: ArtChart,
  doc: ArtDoc,
  users: ArtUsers,
  mega: ArtMega,
  search: ArtSearch,
};

export function EmptyArt({ kind = 'box', size = 150 }) {
  const C = KINDS[kind] || ArtBox;
  return (
    <div className="empty-art">
      <C size={size} />
    </div>
  );
}

export function EmptyState({ kind = 'box', size = 150, title, children }) {
  return (
    <div className="empty">
      <EmptyArt kind={kind} size={size} />
      {title ? <div className="empty-title">{title}</div> : null}
      {children}
    </div>
  );
}
